import React, { useEffect } from "react";
import styles from "./AudioTrim.module.scss";
import { parseTimestamp } from "./parseTimestamp";
import ShowIf from "../../components/ShowIf";
import i18n from "../../constants/i18n";

interface AudioTrimInputsProps {
    start: string;
    end: string;
    onSave: () => void;
    isLoading: boolean;
    markStart: () => void;
    markEnd: () => void;
}

export function AudioTrimInputs({
    start,
    end,
    onSave,
    isLoading,
    markStart,
    markEnd,
}: AudioTrimInputsProps) {
    const [valid, setValid] = React.useState(true);

    const validateInput = React.useCallback(
        (startTime: string, endTime: string) => {
            const startMs = parseTimestamp(startTime);
            const endMs = parseTimestamp(endTime);
            if (startMs > endMs) {
                setValid(false);
                return;
            }

            setValid(true);
        },
        []
    );

    useEffect(() => {
        validateInput(start, end);
    }, [validateInput, start, end]);

    return (
        <div className={styles.container}>
            <div className={`help ${styles.trimInfo}`}>
                <ul className={` ${styles.instructionList}`}>
                    <li>
                        <span />
                        {i18n.audioTrim.instruction1}
                    </li>
                    <li>{i18n.audioTrim.instruction2}</li>
                    <li>{i18n.audioTrim.instruction3}</li>
                    <li>{i18n.audioTrim.instruction4}</li>
                </ul>
            </div>
            <div className={styles.inputs}>
                {/* Start time input and button */}
                <div>
                    <div className="is-flex">
                        <input
                            className={`input ${!valid ? "is-danger" : ""}`}
                            type="text"
                            disabled
                            value={start}
                        />
                        <button
                            className="button is-secondary is-small"
                            onClick={markStart}
                        >
                            {i18n.audioTrim.captureStart}
                        </button>
                    </div>
                </div>
                {/* End time input and button */}
                <div>
                    <div className="is-flex">
                        <input
                            className={`input ${!valid ? "is-danger" : ""}`}
                            type="text"
                            disabled
                            value={end}
                        />
                        <button
                            className="button is-secondary is-small"
                            onClick={markEnd}
                        >
                            {i18n.audioTrim.captureEnd}
                        </button>
                    </div>
                </div>
            </div>
            <div>
                <ShowIf condition={!valid}>
                    <span className={`has-text-danger ${styles.errorMessage}`}>
                        {i18n.audioTrim.errorInvalidRange}
                    </span>
                </ShowIf>
                <div className={styles.saveButtonContainer}>
                    <button
                        className="button is-primary is-rounded is-small"
                        onClick={() => {
                            onSave();
                        }}
                        disabled={isLoading || !valid}
                    >
                        {isLoading
                            ? i18n.generic.save + "..."
                            : i18n.audioTrim.trim}
                    </button>
                </div>
            </div>
        </div>
    );
}
